import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
// @ts-ignore
import BcDialog, { CBcDialog, CBcDialogForm } from '@/components/Dialog.vue';
import * as dd from 'dingtalk-jsapi';
import Autocomplete from './components/Autocomplete.vue';
class DataObject {
    constructor(op) {
        const that = this;
        if (op && /object/i.test(typeof op)) {
            Object.keys(op).forEach((k) => {
                that[k] = op[k];
            });
        }
    }
}
let DeviceCheckFlow = class DeviceCheckFlow extends Vue {
    constructor() {
        super();
        this.searchOptions = {
            deviceType: '',
            quickly: '',
            bindingType: 0
        };
        this.formLoading = false;
        this.dlgSerialMgr = new CBcDialog(new CBcDialogForm());
        this.dlgSerial = new CBcDialog(new CBcDialogForm());
        // list: Array<DataObject> = []
        this.onlyMyself = false; /** 是否仅个人 */
        this.defaultCount = 1000; /* 默认展示条数 */
        this.showCount = 1000; /* 最大展示条数 */
        this.maxCount = 0; /* 最大条数条数 */
        this.list = [];
        this.snackbar = new CBcSnackbar();
        this.dialog = {
            editor: -1,
            title: '',
            text: '',
            visible: false,
            persistent: false,
            form: false
        };
        this.dialogLicense = {
            editor: -1,
            title: '',
            text: '',
            visible: false
        };
        this.formSubmiting = false;
        this.formValid = true;
        this.formLicense = {
            serialcode: '',
            days: '',
            deviceID: '',
            deviceType: '',
            creator: '',
            remark: '',
        };
        this.dlgResult = {
            visible: false
        };
        this.dlgPurchase = {
            visible: false,
            registerInput: false,
            registerLicense: '',
        };
        this.licenseValid = /true/i.test('<%- licenseValid %>');
        this.license = {
            code: ''
        };
        this.licenseImgUrl = '';
        this.pageLoading = false;
        this.isDevLiceUpdate = false;
        this.existCustomerName = [];
        this.scanData = {}; // 扫码内容
        const that = this;
        this.formData = new DataObject({
            type: '',
            name: '',
            mode: '',
            deviceId: '',
            deviceNo: '',
            serialNumber: '',
        });
        this.currentItem = {
            type: '',
            name: '',
            deviceId: '',
            serialNumber: '',
        };
    }
    get routeQuery() {
        const that = this;
        return that.$router.currentRoute.query || {};
    }
    get devLiceUpdateValue() {
        const that = this;
        return that.routeQuery.devLiceUpTxt;
    }
    get devLiceUpdateCryptType() {
        const that = this;
        return that.routeQuery.et;
    }
    get devNodeVersion() {
        const that = this;
        return that.routeQuery.v || '';
    }
    async mounted() {
        // const that: any = this;
        // const deviceSerial = that.routeQuery.serial
        // const deviceNo = that.routeQuery.no
        // this.getSerialList().then((ser: any) => {
        //   if (that.listSerial.length && that.isDevLiceUpdate && deviceSerial) {
        //     that.listSerial.forEach((its: any) => {
        //       if (its.serial.toLocaleLowerCase() === deviceSerial.toLowerCase()) {
        //         that.searchOptions.deviceMode = its.serial
        //       }
        //     })
        //   }
        // });
        const that = this;
        this.getList(this.defaultCount);
        // that.isDevLiceUpdate = (!!that.devLiceUpdateValue)
        // if (that.isDevLiceUpdate) {
        //   if (deviceNo) {
        //     that.searchOptions.quickly = deviceNo
        //   }
        //   that.$clipboard(that.devLiceUpdateValue)
        //   that.snackbar.info('请选择需要授权的设备')
        // }
        // const deviceInfo = that.$route.params || {}
        // if (deviceInfo.deviceNo) {
        //   that.searchOptions.quickly = deviceInfo.deviceNo
        // }
        // 客户名称中合并医院信息，因为大部分客户就是已医院为单位
        await this.axios.get('/api/hospital', {
            params: {
                simple: false,
                short: true
            }
        }).then((res) => {
            this.existCustomerName.push(...(res && res.data && res.data.result || []).map((item) => {
                return {
                    hospitalId: item.id,
                    hospitalName: item.name,
                    customerName: item.name,
                    createTime: ''
                };
            }));
        });
        await this.axios.get('/api/devCheck/receiptRecord/custom/name', {})
            .then((res) => {
            // 医院信息有的，已医院信息为主，没有的才在客户中去添加
            const queryCustomName = JSON.parse(JSON.stringify(res.data.result || []));
            queryCustomName.forEach((item) => {
                const exist = this.existCustomerName.find((existItem) => {
                    return existItem.customerName == item.customerName;
                });
                if (!exist) {
                    this.existCustomerName.push(item);
                }
            });
        })
            .catch((e) => {
            this.snackbar.error('获取客户信息出错:' + e.result + ',' + e.info + '!');
        });
    }
    getSerialList() {
        const that = this;
        that.dlgSerialMgr.loading = true;
        return that.fetchDeviceSerialList().then(() => {
            that.dlgSerialMgr.loading = false;
        }).catch((e) => {
            that.dlgSerialMgr.loading = false;
            console.log('error of get device serial: ', e);
            that.snackbar.error('获取设备机型列表出错');
        });
    }
    async linkToHosptail(hospatalName, id) {
        const that = this;
        if (id)
            that.$router.push({ name: 'HospitalInfo', params: { id: id } });
    }
    async linkToDeviceRegister() {
        const that = this;
        that.$router.push({ name: 'Register', params: {} });
    }
    /**
   * 钉钉扫码
   */
    async scanBarcode() {
        const that = this;
        try {
            dd.biz.util.scan({
                type: 'all',
                onSuccess: async function (data) {
                    // onSuccess将在扫码成功之后回调
                    /* data结构
                      { 'text': String}
                    */
                    if (!data.text) {
                        that.snackbar.info('二维码无效，请检查');
                        return;
                    }
                    that.searchOptions.quickly = data.text;
                    try {
                    }
                    catch (e) {
                        that.snackbar.error('二维码内容解析错误，请联系管理员');
                    }
                },
                onFail: function (err) {
                    that.snackbar.error('扫码失败，' + err);
                }
            });
        }
        catch (e) {
            that.snackbar.error('钉钉服务请求失败:\n' + (e && e.toString()));
        }
    }
    searchMyself() {
        this.snackbar.info('快马加鞭研发中');
    }
    /** 获取所有的出库单信息+获取售后记录 */
    async getList(showMax = -1) {
        const that = this;
        that.pageLoading = true;
        try {
            // 获取出库单信息
            const params = {
                withProducts: true,
                keyword: this.searchOptions.quickly,
            };
            // 查询 售后维护记录
            const param = {
                queryCriteria: this.searchOptions.quickly,
            };
            const devUpholdRes = await that.axios.get('/api/devCheck/receiptRecord', { params: param });
            const devUpholdRecord = devUpholdRes.data && devUpholdRes.data.result || [];
            // console.log(JSON.stringify(devUpholdRecord))
            // const res: any = await that.axios.get('/api/erp/order/outbound', { params });
            // const backOrder = res.data && res.data.result || [];
            const backOrder = [];
            let handAddOrderList = []; // 手动添加的订单售后记录
            let lastList = [];
            backOrder.forEach((item) => {
                const existUphold = devUpholdRecord.find((c) => c.outboundOrderId == item.id);
                item.receiptId = existUphold && existUphold.id || null;
                item.outboundOrderId = item.id;
                item.modelNum = this.deviceTypeCount(item.products);
            });
            const backOrderList = backOrder.map((item) => item.id);
            handAddOrderList = devUpholdRecord.filter((item) => !backOrderList.includes(item.outboundOrderId)).map((t) => ({
                ...t,
                receiptId: t.id,
                orderNumber: t.erpOrderNo,
                modelNum: this.deviceTypeCount(t.products)
            }));
            lastList = backOrder;
            // 合并手动添加的订单数据到 list
            if (handAddOrderList.length > 0) {
                lastList = backOrder.concat(handAddOrderList);
            }
            this.maxCount = lastList.length;
            this.showCount = showMax > 0 ? showMax : this.maxCount;
            if (showMax > 0 && lastList.length > showMax) {
                lastList = lastList.slice(0, showMax);
            }
            that.pageLoading = false;
            this.list = lastList;
        }
        catch (e) {
            that.pageLoading = false;
            console.log('error of get list:', e);
            that.snackbar.error(e.info || e.errorInfo || e.result || e.error || e.toString() || '设备信息获取失败.');
        }
    }
    // 查询历史
    async getQueryRecords() {
        let resultList;
        const that = this;
        // 查询 售后记录
        const param = {
            queryCriteria: this.searchOptions.quickly,
        };
        const resAfter = await that.axios.get('/api/devCheck/receiptRecord', { param });
        const dataAfter = resAfter?.data?.result || [];
        dataAfter.forEach((item) => {
            item.orderNumber = item.erpOrderNo;
            item.modelNum = this.deviceTypeCount(item.products);
            item.receiptId = item.id;
        });
        return dataAfter;
    }
    /** 输入框失去焦点 */
    changeTextblur() {
        if (/undefined|null|^\s?$/i.test(this.searchOptions.quickly)) {
            this.getList(this.defaultCount);
        }
        else {
            this.getList();
        }
    }
    get filterDeviceList() {
        const that = this;
        // const data = that.list.filter((v: any) => !that.searchOptions.quickly ? v : new RegExp(that.searchOptions.quickly, 'i').test(v.hospitalName)
        //   || new RegExp(that.searchOptions.quickly, 'i').test(v.hospitalSpell)
        //   || new RegExp(that.searchOptions.quickly, 'i').test(v.deviceList))
        //   .filter((vDT: any) => new RegExp(this.searchOptions.deviceType || '', 'i').test(vDT.type))
        //   .filter((vDM: any) => new RegExp(that.searchOptions.deviceMode || '', 'i').test(vDM.mode))
        //   .filter((vHN: any) => !that.searchOptions.bindingType ? vHN : that.searchOptions.bindingType === 1 ? String(vHN.hospitalName) : !String(vHN.hospitalName))
        // return data;
        // console.log(222)
        return this.list || [];
    }
    /** 设备点击事件 */
    deviceClick(item, queryType = null) {
        // 如果没有订单编号，那么添加售后记录
        this.addAfterRecords(item);
    }
    /** 跳转添加售后记录页面 */
    addDevAfter() {
        this.$router.push({
            name: 'AddAfterDev',
            params: {
            // ...item,
            // queryType: 'overview' //queryType || ''
            }
        });
    }
    editItem(item) {
        const that = this;
        if (that.$refs.refFormDevice)
            that.$refs.refFormDevice.resetValidation();
        that.dialog.persistent = false;
        that.dialog.editor = 2;
        that.dialog.title = '查看设备';
        that.dialog.text = '';
        that.formData = new DataObject(item);
        that.dialog.visible = true;
    }
    close() {
        const that = this;
        that.dialog.visible = false;
    }
    /** 添加售后记录 */
    async addAfterRecords(item) {
        const that = this;
        // console.log(' ----: ',JSON.stringify(item))
        if (item.receiptId) {
            this.$router.push({
                name: 'FlowUphold',
                params: {
                    ...item,
                    queryType: 'overview' // queryType || ''
                }
            });
            return;
        }
        // 添加售后记录
        try {
            // 生成设备明细
            const detailsList = [];
            item.products.forEach((dev) => {
                const deviceInfo = {
                    productInfoId: dev.productInfoId,
                    productName: dev.productName,
                    model: dev.model,
                    specifications: dev.specifications,
                    quantity: dev.quantity,
                    quantityUnit: dev.quantityUnit,
                    remark: dev.remark,
                    receiptId: ''
                };
                detailsList.push(deviceInfo);
            });
            const params = {
                hospitalId: item.hospitalId,
                hospitalName: item.customerName,
                customerInfoId: item.customerInfoId,
                customerName: item.customerName,
                userId: this.userInfo.username,
                userName: this.userInfo.userName,
                erpOrderNo: item.orderNumber || '',
                orderType: item.orderType || '',
                outboundOrderId: item.id,
                detailsList: detailsList,
                address: item?.recipientInfo?.address || '',
            };
            const result = await that.axios.post('/api/devCheck/receiptRecord', params);
            if (!result.data || !result.data.result || !result.data.result.id) {
                that.snackbar.error('当前订单新增售后记录失败，请联系管理员！');
                return;
            }
            else {
                item.receiptId = result.data.result.id;
            }
            this.$router.push({
                name: 'FlowUphold',
                params: {
                    ...item,
                    queryType: 'overview' // queryType || ''
                }
            });
        }
        catch (e) {
            that.snackbar.error(e.result + ',' + e.info + '!' || '售后订单记录新增失败！');
            console.log('售后订单记录新增失败！', e?.result + ',' + e?.info + '!');
        }
    }
    deviceTypeCount(data) {
        // 分组并计算 quantity 的总和
        const grouped = data.reduce((acc, item) => {
            if (!acc[item.model]) {
                acc[item.model] = { quantity: 0, quantityUnit: item.quantityUnit }; // 初始化 quantity 和 type
            }
            acc[item.model].quantity += item.quantity; // 累加 quantity
            return acc;
        }, {});
        // 拼接成所需字符串
        const result = Object.entries(grouped).map(([model, item]) => {
            // 将 item 断言为包含所需属性的类型
            const { quantity, quantityUnit } = item;
            return `${model}(${quantity}${quantityUnit})`;
        }).join(', ');
        return result;
    }
    customerNameChange(value) {
        this.searchOptions.quickly = value && value.customerName || '';
        // 查询项目
        this.getList();
    }
};
__decorate([
    Getter('deviceSerialList')
], DeviceCheckFlow.prototype, "listSerial", void 0);
__decorate([
    Getter
], DeviceCheckFlow.prototype, "userInfo", void 0);
__decorate([
    Getter
], DeviceCheckFlow.prototype, "deviceTypeList", void 0);
__decorate([
    Getter
], DeviceCheckFlow.prototype, "isSrvTestEnv", void 0);
__decorate([
    Action
], DeviceCheckFlow.prototype, "fetchDevices", void 0);
__decorate([
    Action
], DeviceCheckFlow.prototype, "fetchDeviceSerialList", void 0);
DeviceCheckFlow = __decorate([
    Component({
        name: 'DeviceInfo',
        data: () => ({
            formRules: {
                // @ts-ignore
                days: [v => !!v || '请输入天数', v => (/^\d+$/i.test(v)) || '请输入具体天数'],
                // @ts-ignore
                notEmpty: [v => !!v || '该字段为必填项'],
            }
        }),
        components: {
            BcDialog,
            BcSnackbar,
            Autocomplete,
        }
    })
], DeviceCheckFlow);
export default DeviceCheckFlow;
;
